export default {
  fontFamily: ['Manrope', 'sans-serif'].join(','),
  h1: {
    fontSize: '1.5rem',
    lineHeight: '120%',
    fontStyle: 'normal',
    fontWeight: 700,
  },
  h2: {
    fontSize: '1rem',
    lineHeight: '120%',
    fontStyle: 'normal',
    letterSpacing: '-0.05rem',
    fontWeight: 700,
  },
  h3: {
    fontSize: '0.875rem',
    lineHeight: '120%',
    fontStyle: 'normal',
    fontWeight: 700,
  },
  h4: {
    fontSize: '0.75rem',
    lineHeight: '124%',
    fontStyle: 'normal',
    fontWeight: 700,
  },
  h5: {
    fontSize: '1.5rem',
    lineHeight: '130%',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
  h6: {
    fontSize: '1rem',
    lineHeight: '100%',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
  body1: {
    fontSize: '1rem',
    lineHeight: '136%',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: '136%',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
  subtitle1: {
    fontSize: '0.75rem',
    lineHeight: '133%',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
  subtitle2: {
    fontSize: '0.875rem',
    lineHeight: '100%',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/typography.js